import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';

const Portal = ({ children }) => {
    const [container, setContainer] = useState(null);

    useEffect(() => {
        const el = document.createElement('div');
        document.body.appendChild(el);
        setContainer(el);

        return () => {
            document.body.removeChild(el);
        };
    }, []);

    return container ? createPortal(children, container) : null;
};

export default Portal;